import { useHttp } from '@/shared/lib'
import { useQuery } from '@tanstack/vue-query'
import { type Ref } from 'vue'

/**
 * Функция загрузки списка типов объектов
 */
export const useLoadObjectTypes = () => {
  const http = useHttp()

  return useQuery({
    queryKey: ['load_object_types'],
    queryFn: () => http.get(`/manuals/object-types`),
    retry: false,
  })
}

/**
 * Функция загрузки списка определенного типа объектов
 */
export const useLoadObjectType = (objectTypeId: Ref<string>) => {
  const http = useHttp()

  return useQuery({
    queryKey: ['load_object_type', objectTypeId],
    queryFn: () => http.get(`/manuals/object-types/${objectTypeId.value}`),
    retry: false,
    enabled: Boolean(objectTypeId.value),
  })
}

/**
 * Функция получения данных по типам, фигурам и линиям
 */
export const useLoadTypesData = () => {
  const http = useHttp()

  return useQuery({
    queryKey: ['load_types_data'],
    queryFn: () => http.get('/manuals/object-types/full'),
    retry: false,
  })
}
